import { get, post } from '../http-calls';

export const getByDashboard12PeriodsId = async (id = null) => {
    let res = await get(`MADashboard/MADashboard_getDataLast12Periods${id ? `?MADashboardID=${id}` : ''}`, { useAuthToken: true });
    return res;
};
